import { useTranslation } from 'react-i18next'
import FooterSocial from './FooterSocial'

function FooterBottom({ brandName, year, poweredBy, social, variant = 'light', showSocial = false }) {
  const { t } = useTranslation()

  return (
    <div className={`footer-bottom footer-bottom--${variant}`}>
      <div className="footer-bottom__left">
        <p className="footer-bottom__copyright">
          {year} - {brandName}. {t('footer.allRightsReserved')}
        </p>
        <p className="footer-bottom__powered">
          {t('footer.poweredBy')}{' '}
          <a href="https://workitcars.com" target="_blank" rel="noopener noreferrer">
            {poweredBy}
          </a>
        </p>
      </div>
      {showSocial ? <FooterSocial social={social} variant={variant} /> : null}
    </div>
  )
}

export default FooterBottom
